import ReferencialDto from '../../../dto/ReferencialDto'

export default class MethodItem extends ReferencialDto {
    constructor(object) {
        super(object)
        this.id = object.code
        this.status = object.status
        this.headers = ['code', 'name', 'status']
    }
}